<template>
    <div class="row">
        <div class="col-12 col-lg-8">
            <table class="table tabla-resumen table-bordered mb-4 mb-lg-5">
                <tr class="lightgray-content">
                    <th></th>
                    <th>Pedido</th>
                    <th class="price">Precio</th>
                </tr>

                <template v-for="(elem, index) in items">
                    <tr :key="index">
                        <td class="h1 text-center regular">{{ ++index }}</td>
                        <td>
                            <strong class="text-bold h5 d-block mb-1">{{
                                    elem.titulo
                            }}</strong>
                            <template v-if="elem.descripcion">
                                <strong class="text-bold h7 d-block mb-1">{{
                                        elem.descripcion
                                }}</strong>
                            </template>
                        </td>
                        <td>
                            <div class="h3 m-0">{{ elem.price_management_interno_online == 1 ? elem.precio : elem.precio + elem.price_management_online | formatear_precio }}</div>
                        </td>
                    </tr>
                </template>
                <tr>
                    <td colspan="2" style="text-align: right">
                        <span class="total-price h2 m-0">TOTAL: </span>
                    </td>
                    <td>
                        <span class="total-price h2 m-0">{{ total | formatear_precio }}<small>*</small></span>
                    </td>
                </tr>
            </table>
            <div class="form-group">
                <div class="checkbox-container pb-2">
                    <input type="checkbox" name="privacidad" id="privacidad" v-model="privacidad"
                        @change="isAccepted" />
                    <label for="privacidad">
                        He leído y acepto los
                        <router-link :to="{ name: 'legal' }" target="_blank">
                            <span>términos y condiciones legales</span>
                        </router-link>
                        y la
                        <router-link :to="{ name: 'privacidad' }" target="_blank">
                            <span>política de privacidad</span>
                        </router-link>
                    </label>
                </div>
            </div>
            <div class="form-group">
                <div class="checkbox-container pb-2">
                    <input type="checkbox" name="condiciones" id="condiciones" v-model="condiciones"
                        @change="isAccepted" />
                    <label for="condiciones">Acepto las condiciones de compra</label>
                </div>
            </div>
            <div class="form-group">
                <div class="checkbox-container">
                    <input type="checkbox" name="comunicaciones" id="comunicaciones" v-model="comunicaciones"
                        @change="isAccepted" />
                    <label for="comunicaciones">Acepto recibir comunicaciones</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["items"],
    data() {
        return {
            condiciones: false,
            comunicaciones: false,
            error: false,
            privacidad: false,
        };
    },
    created() { },
    computed: {
        total() {
            let total = 0;
            for (let i in this.items) {
                if(this.items[i].price_management_interno_online == 1) {
                    total = total + parseFloat(this.items[i].precio);
                } else {
                    total = total + (parseFloat(this.items[i].precio) + this.items[i].price_management_online);
                }
                
            }
            return total;
        },
        aceptado() {
            return this.condiciones && this.comunicaciones && this.privacidad;
        },
    },
    mounted() { },
    methods: {
        isAccepted(event) {
            this.$emit("isAccepted", this.aceptado);
        },
    },
    components: {},
};
</script>
